import { enumValue } from '~/util/enums';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const logError = (_error: Error, _errorInfo: { componentStack: string }) => {
    // Log this error somewhere. Our own backend, or NewRelic?
};

interface ErrorResponse {
    response?: {
        headers: {
            'x-response-code'?: string;
        };
    };
    // allow other properties
    [x: string | number | symbol]: unknown;
}
export const hasResponseCode = (error: ErrorResponse, code: string) => {
    if (!error?.response?.headers['x-response-code']) return false;
    return (
        parseInt(error.response.headers['x-response-code']) ===
        enumValue(['response', 'code', code])
    );
};
